import { Experiment } from '@ms/yammer-data/dist/state/types';
import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';
import { useCurrentSessionUser } from '@ms/yammer-hooks/dist/session';

import { UseUIFeatureCheck } from '../types';

export const useIsGroupsEnabled: UseUIFeatureCheck = () => {
  const { isGuest } = useCurrentSessionUser();

  return !isGuest;
};

export const useIsCommunityDraftPostEnabled: UseUIFeatureCheck = () =>
  useExperimentTreatmentWithoutReporting(Experiment.DraftPostCommunity) === true;
